import React from 'react';
import SlideDown from 'react-slidedown';
import styled from 'styled-components';

export type Props = {
  readonly title?: React.ReactNode;
  readonly children: React.ReactNode;
  readonly selected?: boolean;
  readonly className?: string;
};

const StyledSlideDownWrapper = styled.div`
  &:first-child {
    transition-property: none;
    transition-duration: 0.4s;
    transition-timing-function: ease-in-out;
    display: flex;
    width: 100%;
  }

  &.transitioning {
    overflow-y: hidden;
  }

  &.closed {
    display: none;
  }
`;

const StyledCard = styled.div<{ readonly selected: boolean }>`
  display: flex;
  flex-direction: column;
  background-color: ${({ theme }) => theme.color('#FFFFFF')};
  border: ${({ selected, theme }) =>
    selected ? `1px solid ${theme.color('#1B1A1F')}` : `1px solid #E3E1EB`};
  border-radius: 8px;
  padding: 16px;
  gap: 10px;
  flex-grow: 1;

  &:hover {
    border: 1px solid ${({ theme }) => theme.color('#B2B1BA')};
  }
`;

export const Card = ({
  title,
  selected = false,
  children,
  className,
}: Props) => (
  <StyledSlideDownWrapper>
    <SlideDown>
      <StyledCard className={className} selected={Boolean(selected)}>
        {title}
        {children}
      </StyledCard>
    </SlideDown>
  </StyledSlideDownWrapper>
);
